import React from "react";
import "./inline-loading-button.scss";

type InlineLoadingButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  children: React.ReactNode;
};

/** Primary action button with inline spinner (no full-screen FrontLoader). */
export function InlineLoadingButton({
  loading = false,
  children,
  className = "",
  disabled,
  type = "button",
  ...rest
}: InlineLoadingButtonProps) {
  return (
    <button
      type={type}
      className={`inline-loading-btn${loading ? " is-loading" : ""} ${className}`.trim()}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span
          className="inline-loading-btn__spinner spinner-border spinner-border-sm"
          role="status"
          aria-hidden
        />
      ) : null}
      <span className="inline-loading-btn__label">{children}</span>
    </button>
  );
}

export default InlineLoadingButton;
